import { PaymentPlanIcon } from "../Icons/Icons";
import React from "react";
import { formatMoney } from "../../utils/amount";

const PaymentBalance = ({ dashboardData }) => {

  const isValidNumber = (value) => !isNaN(parseFloat(value)) && isFinite(value);
  return (
    <div className="flex shadow-custom py-4 mx-5 rounded-2xl">
      <div className="flex px-4 gap-4 border-r-2 border-dashed border-divider items-center">
        <PaymentPlanIcon bgFill="var(--color-success-background)" fill="var(--color-success-main)" />
        <div className="flex flex-col">
          <span className="font-bold text-lg-18 mb-1">
            {formatMoney(isValidNumber(dashboardData?.amount?.eachPaymentAmount)
              ? dashboardData?.amount?.eachPaymentAmount
              : 0)}
          </span>
          <span className="text-[14px]">Single Payment</span>
        </div>
      </div>
      <div className="flex px-4 gap-4 border-r-2 border-dashed border-divider items-center">
        <PaymentPlanIcon bgFill="var(--color-info-background)" fill="var(--color-info-main)" />
        <div className="flex flex-col">
          <span className="font-bold text-lg-18 mb-1">
            {formatMoney(isValidNumber(dashboardData?.amount?.remaining)
              ? dashboardData?.amount?.remaining
              : 0)
            }
          </span>
          <span className="text-[14px]">Remaining Balance</span>
        </div>
      </div>
      <div className="flex px-4 gap-4 items-center">
        <PaymentPlanIcon bgFill="color-mix(in srgb, var(--color-primary-main) 16%, transparent)" fill="var(--color-primary-main)" />
        <div className="flex flex-col">
          <span className="font-bold text-lg-18 mb-1">
            {formatMoney(isValidNumber(dashboardData?.amount?.paid)
              ? dashboardData?.amount?.paid
              : 0)}
          </span>
          <span className="text-[14px]">Paid To Date</span>
        </div>
      </div>
      {/*<div className=" flex px-4 gap-4 items-center max-w-[162px] w-full">*/}
      {/*  <PaymentPlanIcon bgFill="#D1FADF" fill="#12B76A" />*/}
      {/*  <div className="flex flex-col">*/}
      {/*    <span className="font-bold text-lg-18 mb-1">*/}
      {/*      {isValidNumber(dashboardData?.amount?.invoices)*/}
      {/*        ? dashboardData?.amount?.invoices*/}
      {/*        : 0}*/}
      {/*    </span>*/}
      {/*    <span className="text-[14px]">Invoice</span>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  )
}

export default PaymentBalance
